import iMISFetch from "@/utils/iMISFetch";
import { IQA_HISTORY, QUERY_ENDPOINT } from "@/store/constants";
import type { Coupon, HistoryRow } from "@/store/types";

/**
 * GET /api/query?queryname=$/ASI/CouponsUsed[&Id={partyId}]
 *
 * Returns the member's coupon-purchase history, filtered to rows whose
 * CouponCode is one of the member's currently-known coupons (the raw query can
 * include rows for coupons that no longer belong to the member). The party ID
 * is passed explicitly so the IQA returns history for the correct party even
 * after an onbehalfof session ends. Returns [] on a successful-but-empty
 * response; throws on network/5xx.
 */
export async function fetchPurchaseHistory(partyId: string, coupons: Coupon[]): Promise<HistoryRow[]> {
  const result = await iMISFetch<HistoryRow>(QUERY_ENDPOINT, { query: `${IQA_HISTORY}&Id=${partyId}`, limit: 0 });
  if (!result.success) {
    throw new Error(`fetchPurchaseHistory failed: ${result.message || "unknown error"}`);
  }
  const rows = Array.isArray(result.data) ? (result.data as HistoryRow[]) : [];

  const validCouponCodes = new Set(coupons.map((c) => c.CouponCode));
  return rows.filter((row) => row.CouponCode !== undefined && validCouponCodes.has(row.CouponCode));
}
